export default class ThemeAccordian {
  /**
   * 
   * @param {HTMLElement} container - HTMLElement with className "theme-accordian"
   * @param {boolean} autoClose - (default: true) Auto close other accordian items when opening item
   */
  constructor(container, autoClose = true) {
    this.container = container;
    this.autoClose = autoClose;
    this.titles = this.container.querySelectorAll('.theme-accordian__title');
    this.#init();
  }

  #init() {
    this.titles.forEach(el => {
      el.addEventListener('click', () => this.#toggle(el));
    });
  }

  #toggle(el) {
    if (this.autoClose) {
      this.titles.forEach(t => {
        if (t !== el) t.dataset.active = 'false';
      });
    }
    el.dataset.active = el.dataset.active === 'true' ? 'false' : 'true';
  }
}